"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value.toString();
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/toString.js
// module id = 1001
// module chunks = 0